import { Tag } from 'antd';
import React, { ReactElement } from 'react';
import { IDictionary } from '~utilities/IDictionary';
import IQuote from '~Api/Deal/IQuote';
import InterestMethodEnum from '~Api/Deal/DealQuoteInterestMethodEnum';

const interestMethodClasses: IDictionary<string> = {
    [InterestMethodEnum.InterestMethod360]: 'day360',
    [InterestMethodEnum.InterestMethod365]: 'day365',
};

const interestMethodLabels: IDictionary<string> = {
    [InterestMethodEnum.InterestMethod360]: '360 Day',
    [InterestMethodEnum.InterestMethod365]: '365 Day',
};

export default function InterestMethodTag(props: {
    quote: IQuote;
}): ReactElement {
    const { quote } = props;

    return (
        <Tag className={`interest-method-tag ${interestMethodClasses[quote.interestMethod]}`}>
            {interestMethodLabels[quote.interestMethod]}
        </Tag>
    );
}